import {UseMutationOptions, useMutation} from '@tanstack/react-query';
import {API, OAuthCallbackParams, UserFinalizeResponse} from '@chekin/api';

type Props = UseMutationOptions<UserFinalizeResponse, Error, OAuthCallbackParams>;
function useGoogleOAuthCallbackMutation(options: Props = {}) {
  return useMutation<UserFinalizeResponse, Error, OAuthCallbackParams>({
    mutationFn: payload => API.auth.oauthGoogleCallback(payload),
    ...options,
  });
}

export {useGoogleOAuthCallbackMutation};
